// extracted by mini-css-extract-plugin
module.exports = {"rootMaxWidth":"container-module--rootMaxWidth--1NrXj","rootFullSize":"container-module--rootFullSize--3ynJX"};